import { Icon } from "@ui";
import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { getConfig } from "@config";

const getAuthorizeUrl = async ({apiUrl, studyId}: {apiUrl: string, studyId: string}) => {
	const frontendCallbackUrl = `${location.protocol}//${location.host}/r/s/${studyId}/auth`
	const backendCallbackUrl = `${apiUrl}/auth/dokobit/verify?callback=${encodeURIComponent(frontendCallbackUrl)}&study=${studyId}`
	return  `${apiUrl}/auth/dokobit/authenticate?callback=${encodeURIComponent(backendCallbackUrl)}`;
}

export const AuthIcelandLink = defineComponent({

	props:{
		study:{
			type:String,
			required:true,
		}
	},
	setup(props, ctx){
		const loginUrlRef = ref<null | string>(null);

    const apiUrl = getConfig().apiURL

		onMounted(async () => {
			loginUrlRef.value = await getAuthorizeUrl({studyId: props.study, apiUrl})
		})

		return {
			loginUrlRef
		};
	},
	render(){

		const btncls = "btn btn-lg btn-light";
		return (
			<a
			v-on:click={(e:Event) => this.$emit("click", e)}
			class={ `${btncls} btn-light mx-auto border border-dark d-flex shadow-none border-0` }
			style="font-size:1.5em; margin-bottom:1em"
			href={ this.loginUrlRef }
			>
				<img src="/img/Dokobit_by_Signicat_logo.png" style="width:5em;margin-bottom:.1em;margin-right: 1em" class="my-auto"/>
				<Icon name="login-variant" />

			</a>
		)
	},
});
